import { useTheme } from '@mui/material/styles';
import React from 'react'
import { Button } from '@mui/material';

export default function ButtonTheme(props) {
    const theme = useTheme();
    let background;
    let color;
    let backgroundHover;

    if (props.color == 'primary') { 
        background = theme.palette.primary.main
        backgroundHover = theme.palette.primary.light
        color = theme.palette.primary.contrastText
    }
    else if (props.color == 'transparent') {
        background = theme.palette.transparent.main
        backgroundHover = theme.palette.transparent.light
        color = theme.palette.transparent.contrastText
    }
    else if (props.color == 'red') {
        background = theme.palette.red.main
        backgroundHover = theme.palette.red.light
        color = theme.palette.red.contrastText
    }
    else if (props.color == 'DarkRed') {
        background = theme.palette.DarkRed.main
        backgroundHover = theme.palette.DarkRed.light
        color = theme.palette.DarkRed.contrastText
    }
    else if (props.color == 'white') {
        background = '#D0D5DD'
        backgroundHover = theme.palette.secondary.light
        color = 'white !important'
    }
    else if (props.color == 'blue') {
        background = theme.palette.blue.main
        backgroundHover = theme.palette.blue.light
        color = theme.palette.blue.contrastText
    }
    else if (props.color == 'DarkGreen') {
        background = theme.palette.DarkGreen.main
        backgroundHover = theme.palette.DarkGreen.light
        color = theme.palette.DarkGreen.contrastText
    }
    else if (props.color == 'red') {
        background = theme.palette.red.main
        backgroundHover = theme.palette.red.light
        color = theme.palette.red.contrastText
    }
    else {
        background = theme.palette.secondary.main
        backgroundHover = theme.palette.secondary.light
        color = theme.palette.secondary.contrastText
    }

    return <Button {...props} 
        sx={{
            backgroundColor: background, color: color, borderRadius: '0px',
            border:'1px solid transparent',
            '&:hover': props.color === 'primary' ? {
                backgroundColor: backgroundHover,
                border: '1px solid #BF1D2D',
                color: '#BF1D2D',
            } : {
                backgroundColor: backgroundHover,
                color:color,
            },
            '&:disabled': {
                backgroundColor: '#D0D5DD',
                color:'#fff',
                border:'1px solid #D0D5DD',
            },
            '&:focus': props.color === 'primary' ? {
                backgroundColor: '#FF403F',
                border:'1px solid #FF403F',
                color:'#fff'
            } : {
                backgroundColor: backgroundHover,
            },
    }} >{props.children}</Button>
}

